import UAParser from 'ua-parser-js';

export const browserInfo = () => {
    const parser = new UAParser();
    return parser.getResult();
};